import $ from 'jquery';

$(function() {

    //console.log('product-prices.js');

    // Temporarily disabled to allow page load optimisation

    //initProductIndexPriceLookup();

    initProductIndexPagePrices();
    initProductIndexOrderItem();
    initModifyQuantityButtons();

    initFavouritesHideImages();
    initCampaignHideImages();

    initRemoveFavourite();

});


function initProductIndexPagePrices() {

    // This uses stored data from the PriceList Interface to get product list prices
    //console.log('initProductIndexPagePrices');

    let accountCode = $('#account-code').val();
    if (!accountCode) { return; }

    //let $productControls = $('.product-controls.product-tile');
    let $productControls = $('.product-tile-view-price')
    let productControlsLength = $productControls.length;

    let productCodes = [];

    $productControls.each(function(index, item) {
        productCodes.push($(this).attr('data-product-code'));
    });

    //console.log(productCodes);

    let data = {
        account_code: accountCode,
        product_codes: productCodes
    };

    //console.log(data);

    //getListPrices(data);

    // Get all availability in one go
    getListAvailability(data);

    // Or do it one by one
    // productCodes.forEach(function(productCode) {
    //
    //     let availabilityData = {
    //         account_code: accountCode,
    //         product_codes: productCode
    //     }
    //
    //     console.log(availabilityData);
    //
    //     getProductAvailability(availabilityData);
    //
    // });

}



function getListAvailability(data) {

    axios.post('/product/get-list-availability', data).then(function (response) {

        //console.log(response);

        if (!response.data) {

            // Something went wrong - badly formatted result
            console.log('The server returned badly formed data');
            console.log(response);

        } else if (!response.data.product_availability) {

            // The server returned an error of some sort
            console.log('The server returned an error of some sort');
            console.log(response);

        } else {

            // Let's assume for the moment we have well-formed data ...
            //console.log('The server returned well-formed data');
            //console.log($priceBlock);

            let productAvailability = response.data.product_availability;

            //console.log(productAvailability);
            //console.log(Object.keys(productAvailability));

            Object.keys(productAvailability).forEach(function(productCode) {
                //console.log(productCode);
                //console.log(productAvailability[productCode]);

                let stockLevel = parseInt(productAvailability[productCode]);
                //let $priceBlock = $('.product-controls.product-tile[data-product-code=' + productCode + ']').first();
                let $priceBlock = $('.product-tile-view-price[data-product-code=' + productCode + ']').first();

                // Check if we have any in stock
                if (stockLevel === 0) {
                    // Set the out of stock flag
                    $priceBlock.siblings('.product-out-of-stock-badge').css('display', 'block');
                    //$priceBlock.find('.product-add-to-cart').addClass('hide');
                    $priceBlock.find('a').html('View');
                    $priceBlock.removeClass('hidden');
                } else {
                    // Show the order panel
                    $priceBlock.siblings('.product-out-of-stock-badge').css('display', 'none');
                    //$priceBlock.find('.product-add-to-cart').removeClass('hide');
                    $priceBlock.find('a').html('View price &amp; buy');
                    $priceBlock.removeClass('hidden');
                }

            });

        }

    })["catch"](function (error) {
        console.log(error);
    });

}


function getListPrices(data) {

    axios.post('/product/get-list-prices', data).then(function (response) {

        //console.log(response);

        if (!response.data) {

            // Something went wrong - badly formatted result
            console.log('The server returned badly formed data');
            console.log(response);

        } else if (!response.data.product_prices) {

            // The server returned an error of some sort
            console.log('The server returned an error of some sort');
            console.log(response);

        } else {

            // Let's assume for the moment we have well-formed data ...
            //console.log('The server returned well-formed data');
            //console.log($priceBlock);

            let productPrices = response.data.product_prices;

            //console.log(productPrices);
            //console.log(Object.keys(productPrices));

            Object.keys(productPrices).forEach(function(productCode) {
                //console.log(productCode);
                //console.log(productPrices[productCode]);

                let listPrice = parseFloat(productPrices[productCode]);

                let $priceBlock = $('.product-controls.product-tile[data-product-code=' + productCode + ']').first();
                $priceBlock.find('.currentpricevalue').text('£' + listPrice.toFixed(2));
                $priceBlock.find('.order-button').closest('.ajax-order-form').attr('data-price', listPrice.toFixed(2));
                $priceBlock.removeClass('hide');

            });

        }

    })["catch"](function (error) {
        console.log(error);
    });

}


function initProductIndexPriceLookup() {

    let accountCode = $('#account-code').val();

    if (!accountCode) { return; }

    //console.log('initProductIndexPriceLookup');
    //const start = Date.now();

    let $productControls = $('.product-controls');
    let productControlsLength = $productControls.length;

    // Go through each product on the page and update the customer specific prices
    $productControls.each(function(index, item) {

        let $priceBlock = $(this);

        let productCode = $priceBlock.attr('data-product-code');

        let data = {
            product_code: productCode
        };

        //console.log(data);

        let targetUrl = '/product/get-customer-price';

        axios.post(targetUrl, data).then(function (response) {

            //console.log(response);

            //if (index === (productControlsLength - 1)) {
            //let duration = Date.now() - start;
            //console.log('initProductIndexPriceLookup: ' + duration + 'ms');
            //console.log(response);
            //}

            if (!response.data) {

                // Something went wrong - badly formatted result
                console.log('The server returned badly formed data');
                console.log(response);

            } else if (!response.data.product_code) {

                // The server returned an error of some sort
                console.log('The server returned an error of some sort');
                console.log(response);

            } else {
                // Let's assume for the moment we have well-formed data ...
                //console.log('The server returned well-formed data');
                //console.log($priceBlock);

                let price = parseFloat(response.data.price);
                let retailPrice = parseFloat(response.data.retail_price);
                let listPrice = parseFloat(response.data.list_price);

                // Set the price if it is set
                if (price != 0) {
                    // Check if this is a last chance page ...
                    if ($priceBlock.find('.oldpricevalue').length) {
                        if (price < retailPrice) {
                            $priceBlock.find('.currentpricevalue').text('£' + price.toFixed(2));
                        } else {
                            $priceBlock.find('.currentpricevalue').text('£' + retailPrice.toFixed(2));
                        }
                        $priceBlock.find('.oldpricevalue').text('£' + listPrice.toFixed(2));
                    } else {
                        // Commented out as the whole list price thing is apparently a bit controversial ...
                        //if (listPrice > price) {
                        //    $priceBlock.find('.listpricevalue').text('List £' + listPrice.toFixed(2));
                        //}
                        $priceBlock.find('.currentpricevalue').text('£' + price.toFixed(2));
                    }
                    $priceBlock.removeClass('hide');
                }

                // Check if we have any in stock
                if (!response.data.in_stock) {
                    // Set the out of stock flag
                    $priceBlock.siblings('.product-out-of-stock-badge').css('display', 'block');
                } else {
                    // Show the order panel
                    $priceBlock.find('.order-button').closest('.ajax-order-form').attr('data-price', price.toFixed(2));
                    $priceBlock.find('.product-add-to-cart').removeClass('hide');
                }

            }

        })["catch"](function (error) {
            console.log(error);
        });

    });

}


function initProductIndexOrderItem() {

    //console.log('initProductIndexOrderItem');

    $('.ajax-order-form .order-button').unbind('click');
    $('.ajax-order-form .order-button').on('click', function(event) {

        event.preventDefault();

        //console.log('order-button:click');

        let button = $(this);
        let quantity = button.closest('.ajax-order-form').find('input.order-quantity').val();
        let productVariantId = button.closest('.product-controls').attr('data-product-variant-id');
        let price = button.closest('.ajax-order-form').attr('data-price');

        button.html('Adding <i class="fas fa-circle-notch fa-spin">');

        //console.log(productVariantId, quantity, price);

        let data = {
            productVariantId: productVariantId,
            itemQuantity: quantity,
            itemPrice: price
        };
        let targetUrl = '/manager/ecommerce/basket/add-item';
        axios.post(targetUrl, data).then(function (response) {
            //console.log(response);

            if (!response.data) {
                // Something went wrong - badly formatted result
                //console.log('The server returned badly formed data');
                //console.log(response);
            } else {

                if(response.data.result === 'error') {

                    showBasketError();

                } else {

                    // Update the basket total
                    $('#basket-count').text(response.data.basket_item_count);
                    $('#current_basket_count').removeClass('hide');

                    showBasketUpdated();

                    // Update the mini basket, if present
                    updateMiniBasket(response.data);
                    // Update the full basket if present
                    customUpdateBasket(response.data);

                }

                button.html('Order');
            }

        })["catch"](function (error) {
            console.log(error);
        });

    });

}

function showBasketUpdated() {

    let alert = '<div id="basketUpdated" style="display:none;"><div><p>Added to basket</p></div><div>You have just added that item to your basket<br /> <a href="/account/basket">View your basket</a></div></div>';

    $('#main').append(alert);
    $('#basketUpdated').fadeIn(300);

    setTimeout(function() {
        $('#basketUpdated').fadeOut(300, function() { $(this).remove(); });
    }, 3000);

}

function showBasketError() {

    let alert = '<div id="basketUpdated" style="display:none;"><div><p>Could not add to basket</p></div><div>Sorry, there was an error and your basket was not updated</div></div>';

    $('#main').append(alert);
    $('#basketUpdated').fadeIn(300);

    setTimeout(function() {
        $('#basketUpdated').fadeOut(300, function() { $(this).remove(); });
    }, 3000);

}


function updateMiniBasket(basketDetails) {

    // Check if the mini basket is present
    if (!$('.tbl-basketmini').length) {
        return;
    }

    let currencySymbol = basketDetails.currency_symbol;
    let $miniBasket = $('<table cellPadding="0" cellSpacing="0" class="tbl-basketmini"><tbody></tbody></table>');

    basketDetails.items.forEach((item) => {
        $miniBasket.find('tbody').append($([
            '<tr>',
            '<td><span>' + item.quantity + ' x ' + item.title + '</span><br>' + item.size + ' ' + item.abv + '</td>',
            '<td>' + currencySymbol + item.item_gross + '</td>',
            '<tr>'
        ].join('')));
    });

    $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">Subtotal:</td><td class="basketminittl">' + currencySymbol + basketDetails.item_total + '</td></tr>'));
    if (basketDetails.shipping_net) {
        $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">Shipping:</td><td class="basketminittl">' + currencySymbol + basketDetails.shipping_net + '</td></tr>'));
    }
    $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">VAT:</td><td class="basketminittl">' + currencySymbol + basketDetails.tax + '</td></tr>'));
    $miniBasket.find('tbody').append($('<tr><td class="basketminilbl">Gross Total:</td><td class="basketminittl">' + currencySymbol + basketDetails.gross_total + '</td></tr>'));

    $('.tbl-basketmini').replaceWith($miniBasket);

    if (basketDetails.items.length) {
        $('.btn-continue').removeClass('hide');
    } else {
        $('.btn-continue').addClass('hide');
    }

}


window.customUpdateBasket = function (basketDetails) {

    console.log('product-prices.js->customUpdateBasket');
    //console.log(basketDetails);

    // Add handling of minimum order level warning message ...
    let messages = [];

    // Stock level error message
    if (basketDetails.has_out_of_stock_items || basketDetails.has_insufficient_stock_items) {
        messages.push({
            type: 'error',
            message: 'WARNING: You cannot continue your order - there is not enough stock available for the order lines indicated below. Please amend the quantity or delete the order line(s) to continue.'
        });
    }

    // Minimum order warning
    if (basketDetails.minimum_order_num > basketDetails.item_total_num) {
        messages.push({
            type: 'warning',
            message: 'Your basket item total is currently below your minimum order level. ' +
                     'Add £' + (basketDetails.minimum_order_num - basketDetails.item_total_num).toFixed(2) + ' to avoid shipping charges.'
        });
    }

    // Clear existing flash messages
    $('.flash-message').remove();

    if (messages.length) {
        let messageHtml = '';
        messages.forEach(function(message) {
            messageHtml += '<div class="flash-message ' + message.type + '">' + message.message + '</div>'
        });
        $(messageHtml).insertBefore('div.basket');
    }

    // Show / hide the Checkout button
    if ((basketDetails.has_insufficient_stock_items) || (basketDetails.has_out_of_stock_items)) {
        $('form.custom-order-details button.primary').addClass('hidden');
        $('form.custom-order-details div.custom-order-details-wrapper').addClass('hidden');
    } else {
        $('form.custom-order-details button.primary').removeClass('hidden');
        $('form.custom-order-details div.custom-order-details-wrapper').removeClass('hidden');
    }

    // Check if the basket is present
    if (!$('.tblbasket').length) {
        return;
    }

    let currencySymbol = basketDetails.currency_symbol;
    let $basket = $('.tblbasket');

    basketDetails.items.forEach((item) => {
        let $basketItemRow = $('[data-item-id="' + item['item_id'] + '"]');
        if ($basketItemRow.length > 0) {
            $basketItemRow.find('.basket-item-quantity').val(item['quantity']);
            $basketItemRow.find('.basket-item-total').text(' ' + currencySymbol + item['item_net'] + ' ');
            //console.log($basketItemRow, item['item_net']);
            // Add or remove stock warning
            let $itemOutOfStockSpan = $basketItemRow.find('.item-out-of-stock').first();
            if (item['stock_level'] == 0) {
                if ($itemOutOfStockSpan.length == 0) {
                    $('<span class="item-out-of-stock">This product is currently out of stock</span>').insertAfter($basketItemRow.find('.product-title a'));
                } else {
                    $itemOutOfStockSpan.text('This product is currently out of stock');
                }
            } else if (item['stock_level'] < item['quantity']) {
                if ($itemOutOfStockSpan.length == 0) {
                    $('<span class="item-out-of-stock">Insufficient stock: only ' + item['stock_level'] + ' available</span>').insertAfter($basketItemRow.find('.product-title a'));
                } else {
                    $itemOutOfStockSpan.text('Insufficient stock: only ' + item['stock_level'] + ' available');
                }
            } else {
                if ($itemOutOfStockSpan.length > 0) {
                    $itemOutOfStockSpan.remove();
                }
            }
        } else {
            let stockWarning = '';
            if (item['stock_level'] == 0) {
                stockWarning = '<span class="item-out-of-stock">This product is currently out of stock</span>';
            } else if (item['stock_level'] < item['quantity']) {
                stockWarning = '<span class="item-out-of-stock">Insufficient stock: only ' + item['stock_level'] + ' available</span>';
            }
            let $itemRow = $('<tr data-basket-item-id="' + item['item_id'] + '">' +
                '<td class="basketdel"><i class="fa-regular fa-trash-can basket-item-delete" data-basket-item-id="' + item['item_id'] + '"></i></td>' +
                '<td class="">' + item['product_code'] + '</td>' +
                '<td class=""><a href="' + item['title'] + '">' + item['title'] + '</a>' + stockWarning + '</td>' +
                '<td class="size">' + item['size'] + '</td>' +
                '<td class="abv">' + item['abv'] + '</td>' +
                '<td class="basketrt basket-item-price-excluding-tax"> ' + currencySymbol + item['price_array']['price_excluding_tax'] + ' </td>' +
                '<td class="basketrt"><input type="number" class="basketqty basket-item-quantity" data-basket-item-id="' + item['item_id'] + '" value="' + item['quantity'] + '"></td>' +
                '<td class="basketttl basket-item-net">' +
                '<div class="basket-loader hidden"><i class="fas fa-circle-notch fa-spin"></i></div>' +
                '<span class="basket-item-total"> ' + currencySymbol + item['item_net'] + ' </span>' +
                '</td>' +
                '</tr>');
            let $subtitleRow = $basket.find('.basket-item-net').parent();
            $itemRow.insertBefore($subtitleRow);
        }
    });

    let $basketItemTotal = $('#basket-item-total').first();
    $basketItemTotal.text(' ' + currencySymbol + basketDetails.item_total + ' ');

    let $basketDiscount = $('#basket-discount').first();
    $basketDiscount.text(' ' + currencySymbol + basketDetails.discount + ' ');
    if (basketDetails.discount_num == 0) {
        $basketDiscount.addClass('basket-hidden');
    } else {
        $basketDiscount.removeClass('basket-hidden');
    }

    let $basketShipping = $('#basket-shipping').first();
    $basketShipping.text(' ' + currencySymbol + basketDetails.shipping_net + ' ');
    if (basketDetails.shipping_net_num == 0) {
        $basketShipping.closest('.basket__totals__row').addClass('hidden');
    } else {
        $basketShipping.closest('.basket__totals__row').removeClass('hidden');
    }

    let $basketTax = $('#basket-tax').first();
    $basketTax.text(' ' + currencySymbol + basketDetails.tax + ' ');

    let $basketGrossTotal = $('#basket-gross-total').first();
    $basketGrossTotal.text(' ' + currencySymbol + basketDetails.gross_total + ' ');

    showBasketChanged();

}


function initModifyQuantityButtons() {

    //console.log('initModifyQuantityButtons');

    $('.modify-quantity').unbind('click');
    $('.modify-quantity').on('click', function() {
        let $container = $(this).parent();
        let $quantity = $container.find('.quantity');
        let val = $quantity.val();

        if ($(this).hasClass('increase')) {
            val++;
        } else if ($(this).hasClass('decrease')) {
            val--;
        }
        if (val < 0) {
            val = 0;
        }

        $quantity.val(val);

        if($quantity.hasClass('basket-item-quantity')) {
            updateBasketItem($quantity);
        }
    });

}


function initFavouritesHideImages() {

    $('#favourites-hide-images').unbind('change');
    $('#favourites-hide-images').on('change', function() {
        let url = window.location.href.split('?')[0];
        if ($(this).is(':checked')) {
            // Need to reload without images
            window.location.href = url + '?hi';
        } else {
            window.location.href = url;
        }
    });

}


function initRemoveFavourite() {

    $('.remove-favourite').unbind('click');
    $('.remove-favourite').on('click', function() {

        let productVariantId = $(this).attr('data-product-variant-id');

        let url = window.location.pathname;
        let queryParams = new URLSearchParams(window.location.search);
        queryParams.set('remove', productVariantId);
        window.location.href = url + '?' + queryParams.toString();

    });

}


function initCampaignHideImages() {

    $('#campaign-hide-images').unbind('change');
    $('#campaign-hide-images').on('change', function() {
        let url = window.location.href.split('?')[0];
        if ($(this).is(':checked')) {
            // Need to reload without images
            window.location.href = url + '?hi';
        } else {
            window.location.href = url;
        }
    });

}
